// extracted by mini-css-extract-plugin
export default {"wrapper":"rU3zLuLwHqPbdA0kJZwl"};